module.exports = __webpack_public_path__ + "media/images/realizacje/real16-076d577dd0cdebbfcecb8d14d802b93e.png";